import React, { useState } from 'react';

const BuzzContext = React.createContext({});
export default BuzzContext;

export const BuzzProvider = ({ value, children }) => {
  const [buzz, setValue] = useState(value);

  return (
    <BuzzContext.Provider value={{ buzz, setValue }}>
      {children}
    </BuzzContext.Provider>
  );
};
